<template>
  <div class="ps-login">
    <Alerts />

    <b-container dir="rtl">
      <b-row class="d-flex justify-content-end p-5 mt-5">
        <b-col cols="5" class="shadow-lg p-3 rounded-3 bg-white">
          <b-tabs
            active-nav-item-class="active-coop-btn"
            fill
            dir="rtl"
            v-model="tab"
          >
            <!-- Login Tab -->
            <b-tab title-link-class="coop-btn" title="ورود به سامانه" active>
              <b-row class="p-3 py-1">
                <b-col cols="12" class="my-3">
                  <b-form-input
                    v-model="form.username"
                    name="mobile"
                    :placeholder="label.form.username"
                    class="text-center"
                    @keyup.enter="login"
                  />
                </b-col>
                <b-col cols="12" class="my-3">
                  <b-form-input
                    v-model="form.password"
                    :placeholder="label.form.password"
                    type="password"
                    class="text-center"
                    @keyup.enter="login"
                  />
                </b-col>

                <b-col cols="6" class="text-center mt-3">
                  <img
                    :src="captcha.dntCaptchaImgUrl"
                    alt="captcha"
                    class="login-captcha"
                  />
                </b-col>

                <b-col cols="6" class="d-flex my-3">
                  <b-icon
                    icon="arrow-clockwise"
                    class="mouse-change mt-2 ms-2"
                    scale="1.5"
                    id="captchaRefreshTlp"
                    @click="reloadCaptcha"
                  />
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    target="captchaRefreshTlp"
                  >
                    بارگذاری مجدد کپچا
                  </b-tooltip>
                  <b-form-input
                    v-model="form.captcha"
                    name="captchaCode"
                    type="number"
                    :placeholder="label.form.captcha"
                    class="text-center"
                    @keyup.enter="login"
                  />
                </b-col>

                <b-col cols="12" class="text-center mt-3 mb-2">
                  <b-button
                    v-if="!loadingBtn"
                    variant="ps-success"
                    size="sm"
                    class="px-5"
                    @click="login"
                  >
                    <b-icon
                      icon="box-arrow-in-left"
                      class="ms-2 align-middle"
                    />
                    {{ label.buttons.login }}
                  </b-button>
                  <b-button
                    v-else
                    variant="ps-success"
                    size="sm"
                    class="px-5"
                    disabled
                  >
                    <b-spinner small></b-spinner>
                  </b-button>
                </b-col>
              </b-row>
            </b-tab>

            <!-- Forgot Password Tab -->
            <b-tab title-link-class="coop-btn" title="بازیابی رمز عبور">
              <p class="py-3 p-fs-m text-center p-lh-m">
                جهت دریافت کد اعتبارسنجی، شماره همراه حساب خود را وارد کنید
              </p>
              <b-row class="text-end">
                <b-col class="my-2" cols="12">
                  <label class="p-label pe-3" for="forgotmobile">
                    <b-icon
                      icon="phone-vibrate-fill"
                      scale="1.2"
                      class="ms-1"
                    ></b-icon>
                    شماره موبایل
                  </label>
                  <b-form-input
                    id="forgotmobile"
                    v-model="forgotForm.mobile"
                    class="text-center"
                    type="number"
                    size="sm"
                    placeholder="09121112233"
                    @keyup.enter="sendForgotCode"
                    :disabled="forgotLvl === 2"
                  ></b-form-input>
                </b-col>
                <b-col class="my-2" cols="12" v-if="forgotLvl === 2">
                  <label class="p-label pe-3" for="forgotCode">
                    <b-icon
                      icon="shield-lock-fill"
                      scale="1.1"
                      class="ms-1"
                    ></b-icon>
                    کد احراز هویت
                  </label>
                  <b-form-input
                    id="forgotCode"
                    v-model="forgotForm.code"
                    class="text-center"
                    type="number"
                    size="sm"
                  ></b-form-input>
                </b-col>
                <b-col class="my-2" cols="12" v-if="forgotLvl === 2">
                  <label class="p-label pe-3" for="password">
                    <b-icon
                      icon="unlock-fill"
                      scale="1.2"
                      class="ms-1"
                    ></b-icon>
                    رمز عبور
                  </label>
                  <b-form-input
                    id="password"
                    v-model="forgotForm.password"
                    class="text-center"
                    type="password"
                    size="sm"
                    @keyup.enter="submitForgotCode"
                  ></b-form-input>
                </b-col>
                <b-col class="my-2" cols="12" v-if="forgotLvl === 2">
                  <label class="p-label pe-3" for="repeatPassword">
                    <b-icon
                      icon="unlock-fill"
                      scale="1.2"
                      class="ms-1"
                    ></b-icon>
                    تکرار رمز
                  </label>
                  <b-form-input
                    id="repeatPassword"
                    v-model="forgotForm.repeatPass"
                    class="text-center"
                    type="password"
                    size="sm"
                    @keyup.enter="submitForgotCode"
                  ></b-form-input>
                </b-col>
                <b-col class="mt-4" cols="8">
                  <b-button
                    class="w-100"
                    variant="ps-success"
                    size="sm"
                    @click="sendForgotCode"
                    :disabled="loadingBtn"
                    v-if="forgotLvl === 1"
                  >
                    <span v-if="!loadingBtn"> ارسال کد </span>
                    <b-spinner small v-else></b-spinner>
                  </b-button>
                  <b-button
                    class="w-100"
                    variant="ps-success"
                    size="sm"
                    @click="submitForgotCode"
                    :disabled="loadingBtn"
                    v-if="forgotLvl === 2"
                  >
                    <span v-if="!loadingBtn"> ثبت و ویرایش رمز </span>
                    <b-spinner small v-else></b-spinner>
                  </b-button>
                </b-col>
                <b-col class="mt-4" cols="4">
                  <b-button
                    class="w-100"
                    variant="ps-secondary"
                    size="sm"
                    @click="tab = 0"
                    v-if="forgotLvl === 1"
                  >
                    بازگشت
                  </b-button>
                  <b-button
                    class="w-100"
                    variant="ps-secondary"
                    size="sm"
                    @click="forgotLvl = 1"
                    v-if="forgotLvl === 2"
                  >
                    تغییر شماره
                  </b-button>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Alerts from "@/components/Alerts";
import alert from "@/plugins/AlertMessages.js";
import label from "@/plugins/StaticLabels.js";

export default {
  name: "Login",
  components: {
    Alerts,
  },
  data() {
    return {
      label,
      tab: 0,
      form: {
        username: null,
        password: null,
        captcha: null,
      },
      forgotForm: {
        mobile: null,
        code: null,
        token: "123",
        password: null,
        repeatPass: null,
      },
      forgotLvl: 1,
    };
  },
  computed: {
    ...mapGetters({
      captcha: "captcha",
      loadingBtn: "loadingBtn",
      forgotCheck: "forgotCheck",
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.reloadFields();
      }
    },
    forgotCheck() {
      if (this.forgotCheck) {
        this.forgotLvl = 2;
      }
    },
  },
  methods: {
    login() {
      if (this.form.username && this.form.password) {
        if (this.form.captcha && this.form.captcha.length > 0) {
          this.$store.commit("setLoadingBtn", true);
          let formData = new FormData();
          formData.append("grant_type", "password");
          formData.append("username", this.form.username);
          formData.append("password", this.form.password);
          formData.append("CaptchaInputText", this.form.captcha);
          formData.append("CaptchaText", this.captcha.dntCaptchaTextValue);
          formData.append("CaptchaToken", this.captcha.dntCaptchaTokenValue);
          this.$store.dispatch("login", formData);
        } else {
          this.$store.commit("setError", alert.error.captcha);
        }
      } else {
        this.$store.commit("setError", alert.error.login);
      }
    },
    sendForgotCode() {
      if (this.forgotForm.mobile && this.forgotForm.mobile.length == 11) {
        const payload = {
          token: this.forgotForm.token,
          phoneNumber: this.forgotForm.mobile,
        };
        this.$store.dispatch("forgotPassword", payload);
      } else {
        this.$store.commit("setError", this.alert.error.wrongMobile);
      }
    },
    submitForgotCode() {
      if (this.forgotForm.code && this.forgotForm.code.length > 3) {
        if (this.forgotForm.repeatPass === this.forgotForm.password) {
          const payload = {
            input: this.forgotForm.mobile,
            otp: this.forgotForm.code,
            password: this.forgotForm.password,
            token: this.forgotForm.token,
          };
          this.$store.dispatch("resetPassword", payload);
        } else {
          this.$store.commit("setError", this.alert.error.passwordNotMatch);
        }
      } else {
        this.$store.commit("setError", this.alert.error.wrongCode);
      }
    },
    reloadCaptcha() {
      this.$store.dispatch("getCaptcha");
      this.form.captcha = null;
    },
    reloadFields() {
      this.form = {
        mobile: null,
        password: null,
      };
      this.forgotForm = {
        mobile: null,
        code: null,
        token: "123",
        password: null,
        repeatPass: null,
      };
      this.forgotLvl = 1;
    },
  },
  mounted() {
    this.reloadCaptcha();
  },
};
</script>
